import Button from "../../Button";

const CancelPopUp = ({ handleCancelPopUp, cancelSubscription }) => {
  return (
    <div className="mjwi-popup mjwi-dlt-acnt-pp">
      <div className="dlt-acnt-pp-inner">
        <h2 style={{ color: "black" }}>
          Are you sure you want to cancel this subscription?
        </h2>
        <span style={{ color: "black" }} className="mjwi-popup-close" onClick={() => handleCancelPopUp()}>
          <i className="fa-solid fa-xmark"></i>
        </span>
        <div className="mjwi-row deleteAcntBtns">
          <div className="mjwi-col50">
            <Button
              name="Delete"
              eventHandler={() => cancelSubscription()} // Call cancelSubscription directly
            />
          </div>
          <div className="mjwi-col50">
            <Button name="Cancel" eventHandler={() => handleCancelPopUp()} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelPopUp;
